import { EventSchema, EventTrackerStatusEnum, EventTypeCodeEnum } from '@src/entities/Event/includes/schemas';
import { z } from 'zod';

export * from '../api/requests/mutations/SaveEvent/includes/defaults';
export type * from '../api/requests/mutations/SaveEvent/includes/types';
export * from '../api/requests/queries/GetEvent/includes/defaults';
export type * from '../api/requests/queries/GetEvent/includes/types';
export * from '../api/requests/queries/ListEvents/includes/defaults';
export type * from '../api/requests/queries/ListEvents/includes/types';
export * from '../api/requests/queries/ListEventTypes/includes/defaults';
export type * from '../api/requests/queries/ListEventTypes/includes/types';
export * from './defaults';

export type EventTypeCode = z.infer<typeof EventTypeCodeEnum>;
export type EventTrackerStatus = z.infer<typeof EventTrackerStatusEnum>;
export type EventEntity = z.infer<typeof EventSchema>;
export type EventActions = 'create' | 'edit';
